/**
 * @file 加盟員検索モーダル内の加盟員選択ボタン
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname SelectMemberFromMemberSearchModal
 * @classdesc 加盟員検索モーダル内の加盟員選択ボタン
 */
export default class SelectMemberFromMemberSearchModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 加盟員検索モーダル内の加盟員選択ボタンのjQueryオブジェクト
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('SelectMemberFromMemberSearchModal.constructor')
		this._$e = $e
		this._controller = controller
		this._userId = this._$e.data('user-id')
		this._$selectedMemberWrap = $('.selected-member-from-member-search-modal-wrap')
		this._Modal = bootstrap.Modal.getInstance(document.getElementById('modal-member-search'))
		this._$e.on('click', () => this.onClick())
		this._controller.on('getMemberDataFromMemberSearchModalComplete', () => this.onGetMemberDataFromMemberSearchModalComplete())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof SelectMemberFromMemberSearchModal
	 * @return {undefined}
	 */
	onClick() {
		console.log('SelectMemberFromMemberSearchModal.onClick')
		this._controller.getMemberDataFromMemberSearchModal(this._userId)
	}
	

	/**
	 * 値をセット
	 * 
	 * API仕様を固めることができない段階で実装、
	 * かつ各フォームのnameとレスポンスのプロパティ名はbladeで適宜変更できるように
	 * nameにはform送信時のname、data-response-nameにはレスポンス時のプロパティ名、
	 * data-indexにはjsから特定の要素にアクセスするためのindexが指定されている。
	 *
	 * @memberof SelectMemberFromMemberSearchModal
	 * @return {undefined}
	 */
	setValues(member) {
		console.log('SelectMemberFromMemberSearchModal.setValues')
		console.log(member)
		const getValue = index => member[this._$selectedMemberWrap.find(`[data-index='${index}']`).data('response-name')]
		const getTargetElement = index => this._$selectedMemberWrap.find(`[data-response-name][data-index="${index}"]`)
		const deleteProperty = index => delete member[this._$selectedMemberWrap.find(`[data-index="${index}"]`).data('response-name')]

		// 加入区分
		{
			const responseName = this._$selectedMemberWrap.find(`[data-index="2"]`).data('response-name')
			this._$selectedMemberWrap.find(`[data-response-name="${responseName}"][value="${member[responseName]}"]`).trigger('click')
			deleteProperty(2)
			deleteProperty(3)
			deleteProperty(4)
		}
		// 連盟
		if (getValue(9)) {
			getTargetElement(9).val(getValue(9))
			deleteProperty(9)
			this._controller._listener.trigger('revaluationOrganizations')
		}
		// 地区
		if (getValue(10)) {
			getTargetElement(11).html('').append('<option value="">--</option>')
			getValue(10).forEach(district => getTargetElement(11).append(`<option value="${district.id}">${district.name}</option>`))
			if (getValue(11)) {
				getTargetElement(11).val(getValue(11))
				deleteProperty(10)
				deleteProperty(11)
				this._controller._listener.trigger('revaluationOrganizations')
			}
		}
		// 団
		if (getValue(12)) {
			getTargetElement(13).html('').append('<option value="">--</option>')
			getValue(12).forEach(group => getTargetElement(13).append(`<option value="${group.id}">${group.name}</option>`))
			if (getValue(13)) {
				getTargetElement(13).val(getValue(13))
				deleteProperty(12)
				deleteProperty(13)
				this._controller._listener.trigger('revaluationOrganizations')
				this._controller._listener.trigger('revaluationGroup')
			}
		}
		// 所属
		if (getValue(14)) {
			getTargetElement(15).html('').append('<option value="">--</option>')
			getValue(14).forEach(affiliation => getTargetElement(15).append(`<option value="${affiliation.id}">${affiliation.name}</option>`))
			if (getValue(15)) {
				getTargetElement(15).val(getValue(15))
				deleteProperty(14)
				deleteProperty(15)
			}
		}
		// 役務
		if (getValue(16)) {
			getTargetElement(17).html('').append('<option value="">--</option>')
			getValue(16).forEach(title => getTargetElement(17).append(`<option value="${title.id}">${title.name}</option>`))
			if (getValue(17)) {
				getTargetElement(17).val(getValue(17))
				deleteProperty(16)
				deleteProperty(17)
			}
		}
		// 生年月日
		getTargetElement(19).val(getValue(19)).trigger('change')
		getTargetElement(20).val(Common.zeroPadding(getValue(20), 2)).trigger('change')
		getTargetElement(21).val(Common.zeroPadding(getValue(21), 2))
		deleteProperty(19)
		deleteProperty(20)
		deleteProperty(21)
		// 性別
		{
			const responseName = this._$selectedMemberWrap.find(`[data-index="22"]`).data('response-name')
			this._$selectedMemberWrap.find(`[data-response-name="${responseName}"][value="${member[responseName]}"]`).trigger('click')
			deleteProperty(22)
			deleteProperty(23)
		}
		// その他共通処理
		for (const property in member) {
			this._$selectedMemberWrap.find(`[data-response-name="${property}"]`).val(member[property]).trigger('blur')
		}
	}


	/**
	 * 選択された人のデータ取得完了時コールバック
	 *
	 * @memberof SelectMemberFromMemberSearchModal
	 * @return {undefined}
	 */
	onGetMemberDataFromMemberSearchModalComplete() {
		if (this._userId !== this._controller._currentUserId) return
		console.log('SelectMemberFromMemberSearchModal.onGetMemberDataFromMemberSearchModalComplete')
		this._Modal.hide()
		this.setValues(this._controller._selectedMember)
	}
}
